import { selectIsProduction } from '@socialive/common';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectAppEnvMap } from '~/store';

export default function AppEnvSelector({ handleStudioURLChange, menuEnv }) {
  const isProduction = useSelector(selectIsProduction);
  const appEnvMap = useSelector(selectAppEnvMap);

  if (isProduction) {
    return null;
  }

  // TODO: useCallback
  function changeStudioURL(event) {
    // Please note that this.state.studioURLOverride is ONLY used for this dropdown override.
    // It should never be used for anything user-facing, as it is possible for it to have a null value.
    const env = event.target.value;

    if (env !== menuEnv) {
      handleStudioURLChange(appEnvMap[env] ?? appEnvMap.default);
    }
  }

  // TODO: This should really populate the options based on the envValues object instead of manually duplicating it
  return (
    <select id="devSelectEnv" className="env-select" onChange={changeStudioURL} value={menuEnv}>
      <optgroup label="=== Open in Popup Window ===">
        <option value="default">Default</option>
        <option value="localhost">Local Studio (:1026)</option>
        <option value="localhostGuest">Local Guest (:1027)</option>
        <option value="localhostComposer">Local Composer (:1029)</option>
        <option value="releaseScenes">Release - Scenes (Host Only)</option>
        <option value="releaseCamSS">Release - Cam + Screenshare (Guest Only)</option>
        <option value="stageScenes">Staging - Scenes (Host Only)</option>
        <option value="stageCamSS">Staging - Cam + Screenshare (Guest Only)</option>
        <option value="sbxStudio">SBX Studio</option>
        <option value="sbxGuest">SBX Guest</option>
        <option value="sandbox1">Sandbox 1</option>
        <option value="sandbox2">Sandbox 2</option>
        <option value="sandbox3">Sandbox 3</option>
        <option value="sandbox4">Sandbox 4</option>
        <option value="sandbox5">Sandbox 5</option>
        <option value="qa1">QA 1</option>
        <option value="qa2">QA 2</option>
        <option value="qa3">QA 3</option>
        <option value="qa4">QA 4</option>
        <option value="qa5">QA 5</option>
      </optgroup>
      <optgroup label="=== Open in Tab ===">
        <option value="localhostTab">Local Studio (:1026)</option>
        <option value="localhostGuestTab">Local Guest (:1027)</option>
        <option value="localhostComposerTab">Local Composer (:1029)</option>
        <option value="releaseScenesTab">Release - Scenes (Host Only)</option>
        <option value="releaseCamSSTab">Release - Cam + Screenshare (Guest Only)</option>
        <option value="stageScenesTab">Staging - Scenes (Host Only)</option>
        <option value="stageCamSSTab">Staging - Cam + Screenshare (Guest Only)</option>
        <option value="sbxStudioTab">SBX Studio</option>
        <option value="sbxGuestTab">SBX Guest</option>
        <option value="sandbox1Tab">Sandbox 1</option>
        <option value="sandbox2Tab">Sandbox 2</option>
        <option value="sandbox3Tab">Sandbox 3</option>
        <option value="sandbox4Tab">Sandbox 4</option>
        <option value="sandbox5Tab">Sandbox 5</option>
        <option value="qa1Tab">QA 1</option>
        <option value="qa2Tab">QA 2</option>
        <option value="qa3Tab">QA 3</option>
        <option value="qa4Tab">QA 4</option>
        <option value="qa5Tab">QA 5</option>
      </optgroup>
    </select>
  );
}

AppEnvSelector.propTypes = {
  handleStudioURLChange: PropTypes.func.isRequired,
  menuEnv: PropTypes.string.isRequired,
};
